import { Fish } from "lucide-react";
import { useLang } from "@/i18n";

// Shown while the NicaBros Fishing page (lazy chunk) loads — three little fish swim across.
export function FishingLoader() {
  const { lang } = useLang();
  const fish = [
    { size: 30, color: "#0fd6a8", top: 0, delay: 0 },
    { size: 40, color: "#FFD54F", top: 20, delay: 0.35 },
    { size: 26, color: "#5fd0e6", top: 46, delay: 0.7 },
  ];
  return (
    <div className="fixed inset-0 z-[95] flex flex-col items-center justify-center bg-gradient-to-b from-[#0b2a3d] to-[#061722]" data-testid="fishing-loader">
      {/* faint caustics glow */}
      <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(ellipse 60% 50% at 50% 30%, rgba(15,214,168,0.25), transparent 70%)" }} />
      <div className="relative z-10 w-64 h-24">
        {fish.map((f, i) => (
          <Fish
            key={i}
            size={f.size}
            strokeWidth={2.5}
            className="absolute -scale-x-100"
            style={{ left: 0, top: f.top, color: f.color, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.5))", animation: `nb-swim 2s ${f.delay}s ease-in-out infinite` }}
          />
        ))}
        {/* bubbles */}
        {[0, 1, 2, 3].map((i) => (
          <span key={`b${i}`} className="absolute rounded-full bg-white/40" style={{ width: 5 + (i % 2) * 3, height: 5 + (i % 2) * 3, left: `${20 + i * 22}%`, bottom: 0, animation: `nb-bubble 2.4s ${i * 0.4}s ease-in infinite` }} />
        ))}
      </div>
      <div className="relative z-10 font-pixel text-xs text-white pixel-stroke mt-6 flex items-center gap-1">
        <Fish size={14} strokeWidth={3} className="-scale-x-100 text-[#0fd6a8]" /> NicaBros Fishing
      </div>
      <div className="relative z-10 font-vt text-base text-white/70 mt-1 blink">{lang === "es" ? "Cargando…" : "Loading…"}</div>
      <style>{`
        @keyframes nb-swim {
          0% { transform: translateX(-30px) translateY(0) rotate(-3deg); opacity: .15; }
          50% { transform: translateX(150px) translateY(-8px) rotate(3deg); opacity: 1; }
          100% { transform: translateX(300px) translateY(0) rotate(-3deg); opacity: .1; }
        }
        @keyframes nb-bubble {
          0% { transform: translateY(0) scale(.6); opacity: 0; }
          40% { opacity: .8; }
          100% { transform: translateY(-70px) scale(1); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
